<p-panel header="Anomalies" [toggleable]="true" class="validation-row">
  <ng-template pTemplate="icons">
    <label class="p-panel-header-icon"
           pTooltip="Optionally calculates metrics from anomalies instead of absolute values. First, a climatology is computed using the chosen method and time period (only whole years are used), then the anomalies are calculated based on this. &quot;35 day moving average&quot; means that the climatology is calculated as a moving average of the data; &quot;climatology&quot; means that the average for each day of the year is calculated."
           tooltipPosition="bottom">
      <span class="pi pi-question-circle"></span>
    </label>
  </ng-template>
  
  <div class="mt-5"> 
    <p-floatLabel >
      <p-select id="anomaliesMethodSelector"
                        inputId="anomaliesMethodSelectorId"
                        [options]="availableAnomalyMethodModels"
                        [ngModel]="selectedMethod$|async"
                        (ngModelChange)="selectedMethod$.next($event)"
                        optionLabel="description"
                        [style]="{'width': '100%'}"
      >
      </p-select>
      <label for="anomaliesMethodSelectorId">Select method</label>
    </p-floatLabel>
  </div>
  
  <div>
    @if (((selectedMethod$|async).method$|async) === anomaliesClimatology) {
      <qa-anom-climatology [(anomaliesModel)]="anomaliesModel"/>
    }
  </div>
</p-panel>
